module.exports = __webpack_public_path__ + "static/media/latymerCourt2.259d4507.jpg";